import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <span className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase font-semibold text-lark-blue">
    <span className="h-px w-8 bg-lark-blue/50" />
    {children}
  </span>
);
